import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import PaginatedTable from 'app/components/tables/PaginatedTable';
import { containerFull } from 'app/styles/new-layout';

const useStyles = makeStyles(theme => ({
    container: {
        ...containerFull(theme),
    },
}));

const columns = [
    {
        id: 'status',
        align: 'left',
        disablePadding: true,
        label: 'Status',
        type: 'chip',
        map: {
            'Sent': 'chipPrimary',
            'Scheduled': 'chipWarning',
            'Draft': 'chipDefault',
        }
    },
    { id: 'from_name', align: 'left', label: 'Sent From' },
    { id: 'from_address', align: 'left', label: 'Sent From Address' },
    { id: 'reply_to_name', align: 'left', label: 'Reply To' },
    { id: 'reply_to_address', align: 'left', label: 'Reply To Address' },
    { id: 'formatted_groups', align: 'left', label: 'To' },
    { id: 'subject', align: 'left', label: 'Subject' },
    {
        id: 'sent_at',
        align: 'left',
        disablePadding: false,
        label: 'Sent At',
        type: 'date',
        format: 'ff',
        highlight: true
    },
    { id: 'delivered', align: 'right', label: 'Delivered' },
    { id: 'opened', align: 'right', label: 'Opened' },
    { id: 'clicked', align: 'right', label: 'Clicked' },
    { id: 'failed', align: 'right', label: 'Failed' },
    { id: 'unsubscribed', align: 'right', label: 'Unsubscribed' },
    { id: 'complained', align: 'right', label: 'Complained' },
    {
        id: 'created_at',
        align: 'right',
        disablePadding: false,
        label: 'Date Created',
        type: 'date',
        format: 'ff'
    },
    {
        id: 'updated_at',
        align: 'right',
        disablePadding: false,
        label: 'Last Updated',
        type: 'date',
        format: 'ff'
    },
    {
        id: 'deleted_at',
        align: 'right',
        disablePadding: false,
        label: 'Archived On',
        type: 'date',
        format: 'ff'
    },
];

export default function Emails(props) {

    const classes = useStyles();
    const history = useHistory();

    const onClickFn = (email) => {
        if (email.status === 'Sent') {
            history.push(`/admin/emails/view/${email.id}`);
        } else {
            history.push(`/admin/emails/${email.id}`);
        }
        
    }

    return (
        <div className={classes.container}>
            <PaginatedTable
                columns={columns}
                stateKey="emails"
                label="Emails"
                tableUrl='/email'
                baseUrl='/admin/email'
                viewUrl='/admin/emails'
                newUrl='/admin/emails/0'
                fullHeight
                onClickFn={onClickFn}
            />
        </div>
    );
}
